import { createSelector } from '@reduxjs/toolkit';
import { QUERY_TEMPLATE_OWNER_TYPE_LABEL_MAP } from 'client/views/query/query-utils';
import { OwnerType } from 'common/enums/owner-enums';
import type { IQuery } from 'common/interfaces/query';
import type { RootState } from '../../configureStore';

export interface IQueryListSection {
  key: string;
  nameKey: string;
  sectionQueries: IQuery[];
}

const ALWAYS_LISTED_SECTION_KEYS: string[] = [OwnerType.USER, OwnerType.CUSTOMER];

type TQueryState = RootState['entities']['query'];

const queriesSelector = (queryState: TQueryState) => queryState.queries;

export const getQueryListSections = createSelector(
  queriesSelector,
  (queries): IQueryListSection[] => Object.values(OwnerType)
    .map(ownerType => ({
      key: ownerType,
      nameKey: QUERY_TEMPLATE_OWNER_TYPE_LABEL_MAP[ownerType],
      sectionQueries: queries.filter(query => query.ownerType === ownerType),
    }))
    .filter(({ key, sectionQueries }) => sectionQueries.length > 0 || ALWAYS_LISTED_SECTION_KEYS.includes(key)),
);
